<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t1">By </span>C<span class="t2">LARE</span> L<span class="t2">ONDON</span></p>
<p class="p0"><span class="t3">N</span><span class="t4">OVELS</span></p>
<p class="p2"><span class="t1">72 Hours</span></p>
<p class="p0"><span class="t1">Branded</span></p>
<p class="p0"><span class="t1">Compulsion</span></p>
<p class="p0"><span class="t1">Sparks Fly</span></p>
<p class="p0"><span class="t1">True Colors</span></p>
<p class="p3"><span class="t3">N</span><span class="t4">OVELLAS</span></p>
<p class="p2"><span class="t1">Footprints</span></p>
<p class="p0"><span class="t1">Just-You Eyes</span></p>
<p class="p0"><span class="t1">Touch</span></p>
<p class="p2"><span class="t1">Ambush</span></p>
<p class="p0"><span class="t1">Payback</span></p>
<p class="p0"><span class="t1">Switch</span></p>
<p class="p2"><span class="t1">Published by </span>D<span class="t2">REAMSPINNER</span> P<span class="t2">RESS</span></p>
<p class="p0"><span class="t1">http://www.dreamspinnerpress.com</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?218e10e5